export default "__VITE_ASSET__Dqx2wfZa__"